import {z} from 'zod';

const id=z.string().regex(/^[A-Za-z0-9][A-Za-z0-9._:-]{0,127}$/u);
const hash=z.string().regex(/^[a-f0-9]{64}$/u);
const day=z.string().regex(/^\d{4}-\d{2}-\d{2}$/u).refine(value=>Number.isFinite(Date.parse(value))&&new Date(value).toISOString().slice(0,10)===value);
export const importedWorkRegisterSchema=z.object({
 schemaVersion:z.literal(1),immutable:z.literal(true),workId:id,version:z.literal(1),
 scope:z.object({kind:z.literal('site'),tenantId:z.literal('kop'),siteId:id}).strict(),
 dateSpec:z.object({kind:z.enum(['single','range','dates']),start:day,end:day,dates:z.array(day).max(366)}).strict(),
 category:z.enum(['휴일작업','비일상작업','긴급작업','기타작업']),
 status:z.enum(['작업종료','작업취소','승인완료','승인대기','반려']),
 company:z.string().trim().min(1).max(500),title:z.string().trim().min(1).max(5000),
 plannedHeadcount:z.number().int().nonnegative().max(100000).nullable(),
 hazards:z.string().max(10000),safetyContact:z.string().max(5000),note:z.string().max(10000),
 documents:z.array(z.object({label:z.string().min(1).max(100),status:z.string().max(1000),reference:z.string().max(10000)}).strict()).length(3),
 source:z.object({fileName:z.string().min(1).max(300),sha256:hash,sheet:z.string().min(1).max(200),row:z.number().int().min(1),sequence:z.string().max(100),cells:z.record(z.string().regex(/^[A-O]$/u),z.string().max(20000))}).strict(),
 importedAt:z.string().datetime(),contentHash:hash,
}).strict().superRefine((entry,ctx)=>{
 const d=entry.dateSpec;
 if(d.start>d.end||(d.kind==='single'&&(d.start!==d.end||d.dates.length!==1||d.dates[0]!==d.start))||
  (d.kind==='dates'&&(!d.dates.length||d.dates[0]!==d.start||d.dates.at(-1)!==d.end||new Set(d.dates).size!==d.dates.length))||
  (d.kind==='range'&&d.dates.length))ctx.addIssue({code:'custom',message:'Invalid work date specification'});
});
export type ImportedWorkRegister=z.infer<typeof importedWorkRegisterSchema>;

/** A ledger entry never grants permit, signature, inspection or approval authority. */
export function importedWorkRegisterRow(entry:ImportedWorkRegister){
 const types={'휴일작업':'holiday','비일상작업':'non-routine','긴급작업':'emergency','기타작업':'other'} as const;
 const statuses={'작업종료':'closed','작업취소':'invalidated','승인완료':'approved','승인대기':'approval-pending','반려':'returned'} as const;
 return {workId:entry.workId,version:entry.version,title:entry.title,contractorName:entry.company,area:'—',
  startsAt:`${entry.dateSpec.start}T00:00:00+09:00`,endsAt:`${entry.dateSpec.end}T23:59:59+09:00`,
  source:'register-import' as const,lifecycle:statuses[entry.status],nextGate:'none' as const,statusSummary:[entry.status],
  evidenceComplete:0,evidenceRequired:0,allowedActions:[],updatedAt:entry.importedAt,imported:entry,
  register:{workTypes:[types[entry.category]],hazardLabels:entry.hazards?[entry.hazards]:[],safetyContacts:entry.safetyContact?[entry.safetyContact]:[],
   plannedHeadcount:entry.plannedHeadcount,remarks:entry.note||null,riskAssessment:'not-recorded' as const,workPlan:'not-applicable' as const,
   workPlanReason:null,patrolCount:0,closeoutRecorded:false}};
}
